import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { DbExercise } from 'src/models/db-exercises.model';
import { DbExercisesService } from 'src/services/db-exercises.service';
import { ExerciseFromDbDetailController } from './exercise-from-db-detail.component.controller';
import { ExerciseFromDbController } from '../exercise-from-db/exercise-from-db.component.controller';
import { firstValueFrom, from } from 'rxjs';
import { ErrorService } from 'src/services/error.service';

@Component({
    selector: 'app-exercise-from-db-detail',
    templateUrl: './exercise-from-db-detail.component.html',
    styleUrls: ['./exercise-from-db-detail.component.scss'],
    standalone: false
})
export class ExerciseFromDbDetailComponent implements OnInit {
  @Input() detail!: DbExercise;
  isPage = false;

  constructor(
    private modalController: ModalController,
    private router: Router,
    private route: ActivatedRoute,
    private dbExerciseService: DbExercisesService,
    private exerciseFromDbControler: ExerciseFromDbDetailController,
    private dbControler: ExerciseFromDbController,
    private errorService: ErrorService
  ) {}

  ngOnInit() {
    this.route.url.subscribe(async (urlSegments) => {
      // Check if the first segment is 'exercises-preview'
      const isOnExercisePreviewRoute =
        urlSegments.length > 0 && urlSegments[0].path === 'exercises-preview';

      // Get the exercise key from the route parameters
      const exerciseKey = this.route.snapshot.paramMap.get('key');

      if (isOnExercisePreviewRoute) {
        let detail = this.dbExerciseService.getExerciseById(exerciseKey!);
        if (!detail) await this.dbExerciseService.fetchAndDecompressData();
        detail = this.dbExerciseService.getExerciseById(exerciseKey!);
        if (detail) {
          this.detail = detail;
          this.isPage = true;
        } else {
          this.router.navigate(['/home/exercises-preview']);
        }
      }
    });
  }

  async addExercise(dbExercise: DbExercise) {
    const exerciseId = await firstValueFrom(
      from(this.dbControler.addExercise(dbExercise))
    );
    if (exerciseId)
      this.errorService.presentSuccess('Exercise added successfully!');
  }

  close() {
    this.modalController.dismiss();
  }

  shareDetail(detailId: string): void {
    this.exerciseFromDbControler.shareDetail(detailId);
  }
}
